"use client";

import Link from "next/link";

import { Glitchy404 } from "@/components/ui/glitchy-404";

export default function GlobalNotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6 bg-surface px-4 text-ink">
      <Glitchy404 width={400} height={108} />
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-xl font-semibold">Page not found</h1>
        <p className="text-sm text-ink-mute">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
      </div>
      <Link
        href="/"
        className="rounded-lg bg-mint px-4 py-2 text-sm font-medium text-landing-bg transition-opacity hover:opacity-90"
      >
        Go to home
      </Link>
    </div>
  );
}
